import React, { useEffect, useState } from 'react'
import sucessPayment from '../../assets/svg/icons/ic-check.svg'
import axiosClient from '../../../axios-client';

const SuccessPayment = () => {
    const [credit, setCredit] = useState(0);
    const [ rechargedPrice, setRechargedPrice ] = useState(0);
    const [ transactionId, setTransactionId ] = useState(0);
    
    useEffect(() => {
        userInfo();
        getInfoTransction();
        // Adding the Google Ads event snippet dynamically
        const script = document.createElement('script');
        script.innerHTML = `
            gtag('event', 'conversion', {
                'send_to': 'AW-16817046360/b5U1CKXbv_UZENiG_9I-',
                'value': ${rechargedPrice}
                'currency': 'USD',
                'transaction_id': ${transactionId},
            });
        `;
        document.body.appendChild(script);

        // Cleanup to remove the script when the component unmounts
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const userInfo = () => {
        axiosClient.get('/user')
            .then(({ data }) => {
                var sifrtName = data.data.name.split(' ');
                setCredit(data.data.credit.credit);
                setfullName(sifrtName[0])
            })
            .catch(() => {})
    }

    const getInfoTransction = () => {
        axiosClient.get('/latest-payment')
            .then(({ data }) => {
                setRechargedPrice(data.data.credit || 0);
                setTransactionId(data.data.transaction_id || '');
            })
            .catch(() => {})
    }

    return (
        <div className='container-fluid'>
            <div className='row justify-content-center align-items-center py-2'>
                <div className='col-md-6 py-5'>
                    <div className='card bg-white border justify-content-center align-items-center'>
                        <idv className='ic-card p-3 mx-auto bg-white rounded-circle'>
                            <img width={52} height={52} src={sucessPayment} />
                        </idv>
                        <div className="card text-center border-0 py-5 bg-transparent">
                            <div className="card-body border-0">
                                <h2 className='text-center title my-3'>Payment completed successfully</h2>
                                <p>Your payment has been completed successfully.</p>
                                <p>Your new balance is now <span className='txt-green bolder'>{credit}</span> credits.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default SuccessPayment